<div class="d-flex bg-blue w-100 text-center padding-10 font-weight-bolder">
    <span class="ml-auto"></span>
    <h2 class="col-md-10">Important News</h2>
    <div class="ml-auto">
<!--        used to open the add article dialog-->
        <button *ngIf="loginService.activeUser.superAdmin"
                mat-button
                matSuffix
                mat-icon-button
                (click)="add()"
                id="add"
        >
            <mat-icon>add</mat-icon>
        </button>
        <!--        used to open the Sort article dialog-->
        <button *ngIf="loginService.activeUser.superAdmin"
                mat-button
                matSuffix
                mat-icon-button
                (click)="sort()"
                id="sort"
        >
            <mat-icon>reorder</mat-icon>
        </button>
    </div>
</div>
    <div class=" news-container flex-wrap border">
<!--        pulls articles from service for syncing sends info to child to make edit and delete easier-->
        <div *ngFor="let item of newsService.news | async | filter: 'News':['catergories']" class="article-container" >
            <flex-article [article]="item" class="w-100"></flex-article>
        </div>
    </div>
